import AuthenticationStorage from "../storage/authentication-storage";
import { SIGN_IN, BERATER_LOGON } from "../actions/types/authentication-types";

export default function reducer(state = AuthenticationStorage, action) {
  switch (action.type) {
    case SIGN_IN: {
      let newState = { ...state };
      newState.signIn(action.payload);
      return newState;
    }
    case BERATER_LOGON: {
      let newState = { ...state };
      newState.beraterLogon(action.payload);
      return newState;
    }
    default:
      return state;
  }
};
